<!--Should we make our own custom progress bars using native html/css div elements
    OR is it ok to keep the material components?-->


<div class="progress-bar-container" [style.width]="width" [style.height]="height">
    <mat-progress-bar 
        mode="determinate" 
        [value]="percentFilled" 
        [style.--buffer-backgroundColor]="backgroundColor"
        [style.--afterFill-backgroundColor]="barFillColor"
        >
    </mat-progress-bar>
</div>
